import { useEffect, useState, useContext } from 'react';
import { BreakdownsContext } from './contexts/BreakdownsContext';
import { BreakdownsContextType } from './contexts/BreakdownsContextTypes';
import {
  platformIconsMapping,
  platformNamesMapping,
} from '../../../utils/platforms';
import Tooltip from '../../../components/Tooltip/Tooltip';
import { Link } from 'react-router-dom';
import { BreakdownsContainer } from '../../../components/BreakdownsContainer/BreakdownsContainer';
import { ReactComponent as VerifiedTwitter } from '../../SourcePage/assets/verifiedTwitter.svg';
import { LoaderSmall } from '../../../components/LoaderSmall/LoaderSmall';
import { cutString } from '../../../utils/cutString';
import { decodeSourceName } from '../../../utils/decodeURI';
import { useTranslation } from 'react-i18next';
import { mapAffiliationEntityTypes } from '../../../utils/actors';
import styles from '../NarrativePage.module.scss';

interface TopStateAffiliatedProps {
  isClickable?: boolean;
  isShare?: boolean;
};

export const TopStateAffiliated: React.FC<TopStateAffiliatedProps> = ({ isShare, isClickable = true }) => {
  const { t } = useTranslation();
  const [topAffiliated, setTopAffiliated] = useState<any | null>(null);

  const {
    stateAffiliated,
    openModal,
    setPlatformsFilter,
    setCurrentWidgetName,
  } = useContext(BreakdownsContext) as BreakdownsContextType;

  const affiliationTypes = mapAffiliationEntityTypes(t);

  useEffect(() => {
    if (!stateAffiliated) return;
    setTopAffiliated(stateAffiliated.top_actors || []);
  }, [stateAffiliated]);

  return (
    <BreakdownsContainer
      title={t('Top state-affiliated actors')}
      details={false}
      flexGrow={1}
    >
      {stateAffiliated ? (
        topAffiliated?.length > 0 ? (
          <div className={styles.breakdownsListMain}>
            {topAffiliated.map((source:any, index:any) => {
              return (
                <div key={`platforms_${index}`} className={styles.listItem}>
                  <div className={styles.info}>
                    <span>{platformIconsMapping[source?.platform]}</span>
                    <span className={styles.title}>
                      {isShare || !isClickable ? (
                        <Tooltip content={source.name} position="bottom">
                          {cutString(decodeSourceName(source.name), 30)}
                        </Tooltip>
                      ) : (
                        <Link to={`/sources/${source.id}`}>
                          <Tooltip content={source.name} position="bottom">
                            {cutString(decodeSourceName(source.name), 30)}
                          </Tooltip>
                          {source?.is_verified ? (
                            <span className={styles.verified}>
                              <VerifiedTwitter />
                            </span>
                          ) : (
                            ''
                          )}
                        </Link>
                      )}

                      <p className={styles.country}>
                        {source?.country_name
                          ? source.country_name
                          : ''}
                      </p>
                    </span>
                  </div>
                  <div className={styles.details}>{affiliationTypes[source?.affiliation_type as keyof typeof affiliationTypes]}</div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.noDataBreakdowns}>
            {t('There is no data to display')}
          </div>
        )
      ) : (
        <div className={styles.widdgetLoader}>
          <LoaderSmall />
        </div>
      )}
    </BreakdownsContainer>
  );
};
